<script>
/* eslint no-console: 0 */
import globalConfigMixin from 'shared/mixins/globalConfigMixin';

export default {
  mixins: [globalConfigMixin],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    classObject() {
      return 'w-full';
    },
    activeIndex() {
      return this.items.findIndex(i => i.route === this.$route.name);
    },
  },
  methods: {
    isActive(item) {
      return this.items.indexOf(item) === this.activeIndex;
    },
    isOver(item) {
      return this.items.indexOf(item) < this.activeIndex;
    },
  },
};
</script>

<template>
  <transition-group
    name="wizard-items"
    tag="div"
    class="wizard-box"
    :class="classObject"
  >
    <div
      v-for="item in items"
      :key="item.route"
      class="item"
      :class="{ active: isActive(item), over: isOver(item) }"
    >
      <div class="flex items-center">
        <h3
          class="text-body text-base font-medium pl-6 overflow-hidden whitespace-nowrap mb-1.5 text-ellipsis leading-tight"
        >
          {{ item.title }}
        </h3>
        <span
          v-if="isOver(item)"
          class="ml-1 text-green-600 dark:text-green-400"
        >
          <fluent-icon icon="checkmark" />
        </span>
      </div>
      <span class="step">
        {{ items.indexOf(item) + 1 }}
      </span>
      <p class="pl-6 m-0 text-sm text-muted">
        {{ item.body }}
      </p>
    </div>
  </transition-group>
</template>

<style lang="scss" scoped>
.wizard-box {
  .item {
    @apply cursor-pointer after:bg-line before:bg-line py-4 pr-4 pl-6 relative
      before:h-4 before:top-0 last:before:h-0 first:before:h-0 last:after:h-0
      before:content-[''] before:absolute before:w-0.5 after:content-['']
      after:h-full after:absolute after:top-5 after:w-0.5;

    &.active {
      h3 {
        @apply text-brand-text;
      }

      .step {
        @apply bg-brand-solid text-on-brand;
      }
    }

    &.over {
      &::after {
        @apply bg-brand;
      }

      .step {
        @apply bg-brand-solid text-on-brand;
      }

      & + .item {
        &::before {
          @apply bg-brand;
        }
      }
    }

    // O numero da etapa nao concluida ficava BRANCO sobre `bg-slate-75`, um
    // cinza quase branco: 1.3:1, ou seja, invisivel. Toda etapa que ainda nao
    // aconteceu aparecia como uma bolinha vazia. Agora o passo pendente usa
    // fundo recuado com texto `muted` (o branco vale so quando o fundo e a cor
    // cheia da marca, nos estados active/over acima).
    .step {
      @apply bg-surface-sunken text-muted rounded-full font-medium w-4 left-4
        leading-4 z-[999] absolute text-center text-xxs top-5;
    }
  }
}
</style>
